var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 18.125V6.875C23.75 5.8375 22.9125 5 21.875 5H4.3625C3.325 5 2.4875 5.8375 2.4875 6.875V18.125C2.4875 19.1625 3.325 20 4.3625 20H21.875C22.9125 20 23.75 19.1625 23.75 18.125ZM22.1125 6.7375C22.525 7.15 22.3 7.575 22.075 7.7875L17 12.4375L21.875 17.5125C22.025 17.6875 22.125 17.9625 21.95 18.15C21.7875 18.35 21.4125 18.3375 21.25 18.2125L15.7875 13.55L13.1125 15.9875L10.45 13.55L4.9875 18.2125C4.825 18.3375 4.45 18.35 4.2875 18.15C4.1125 17.9625 4.2125 17.6875 4.3625 17.5125L9.2375 12.4375L4.1625 7.7875C3.9375 7.575 3.7125 7.15 4.125 6.7375C4.5375 6.325 4.9625 6.525 5.3125 6.825L13.1125 13.125L20.925 6.825C21.275 6.525 21.7 6.325 22.1125 6.7375Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b8ad2091c056cffcd08d8f180d17e275.svg";
export { ForwardRef as ReactComponent };